'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _FundInvestmentProfile = require('./FundInvestmentProfile.css');

var _FundInvestmentProfile2 = _interopRequireDefault(_FundInvestmentProfile);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundInvestmentProfile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  };
}, searchActions), _dec2 = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true, // need otherwise cient navigate is blocked until the page is loaded
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec3 = (0, _reactCssModules2.default)(_FundInvestmentProfile2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundInvestmentProfile, _Component);

  function FundInvestmentProfile(props) {
    (0, _classCallCheck3.default)(this, FundInvestmentProfile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundInvestmentProfile.__proto__ || (0, _getPrototypeOf2.default)(FundInvestmentProfile)).call(this, props));

    _this.handleScroll = function () {
      if (!_this._mounted) {
        return;
      }
      if (!_this.props.result) {
        return;
      }
      // const shareClass = this.props.result.shareClass
      // const scrollTop = event.srcElement.body.scrollTop
    };

    _this.scrollTo = function (id) {
      return function () {
        var ele = document.getElementById(id);
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
      };
    };

    _this.renderStats = function (shareClass) {
      function renderCol(type, entries, hasLine) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 6, styleName: 'col-' + type + '-wrapper' },
          entries.map(function (entry, idx) {
            return _react2.default.createElement(
              'div',
              {
                key: idx,
                styleName: 'col-label-value' },
              _react2.default.createElement(
                'div',
                { styleName: 'col-' + type },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stats-label' },
                  entry.name
                ),
                entry.link ? _react2.default.createElement(
                  _components.Link,
                  {
                    to: entry.link,
                    title: entry.value,
                    xstrong: true
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'stats-value-link' },
                    entry.value,
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                ) : _react2.default.createElement(
                  'div',
                  { styleName: 'stats-value' },
                  entry.value
                )
              ),
              hasLine && idx !== entries.length - 1 ? _react2.default.createElement('div', { styleName: 'col-line' }) : null
            );
          })
        );
      }

      var dest = encodeURIComponent(shareClass.fund_family_name);

      return _react2.default.createElement(
        'div',
        { styleName: 'stats' },
        _react2.default.createElement(
          'div',
          { styleName: 'stats-inner' },
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'stats-header' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 6, md: 6, lg: 6 },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-title' },
                'Fund investment profile'
              )
            ),
            _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 12, sm: 6, md: 6, lg: 6 })
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass ticker', value: shareClass.ticker }], false),
            renderCol('right', [{ name: 'Data as of', value: (0, _moment2.default)(shareClass.date.slice(0, 10)).format('D MMM YYYY') }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass name', value: shareClass.name }], false),
            renderCol('right', [{ name: '% of fund assets screened', value: _format2.default.perc(shareClass.percent_rated) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Shareclass type', value: _format2.default.legalType(shareClass.legal_type) }], false),
            renderCol('right', [{ name: 'Fund net assets', value: _format2.default.money(shareClass.fund_net_assets, true, shareClass.currency) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Fund family', link: _config2.default.routes.families + '?q=' + dest, value: shareClass.fund_family_name }], false),
            renderCol('right', [{ name: 'Fund category', value: shareClass.morningstar_category_name }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Domicile country', value: _format2.default.market(shareClass.market) }], false),
            renderCol('right', [{ name: 'Portfolio currency', value: _format2.default.currencyCode(shareClass.currency) }], false)
          ),
          _react2.default.createElement('div', { styleName: 'line' }),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            null,
            renderCol('left', [{ name: 'Non-diversification risk', value: _format2.default.boolean(shareClass.non_diversified_fund) }], false),
            renderCol('right', [{ name: 'Socially responsible fund', value: _format2.default.boolean(shareClass.socially_responsible_fund || '0') }], false)
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stats-totals' },
            _react2.default.createElement(
              'div',
              { styleName: 'stats-totals-header' },
              'Fossil fuels'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Fossil fuel grade'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'badge-grade-wrap' },
                  _react2.default.createElement(_components.Grade, { grade: shareClass.grade_fossil, blocksmall: true })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total fossil fuel stock holdings'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.number(shareClass.c2f5coogutcount)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total % invested in fossil fuel stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.perc(shareClass.c2f5coogutweight)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total assets invested in fossil fuel stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.money(shareClass.c2f5coogutasset, true, shareClass.currency, false)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stats-totals' },
            _react2.default.createElement(
              'div',
              { styleName: 'stats-totals-header' },
              'Fossil fuel finance'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Fossil fuel finance grade'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'badge-grade-wrap' },
                  _react2.default.createElement(_components.Grade, { grade: shareClass.grade_fossil_bank, blocksmall: true })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Fossil fuel finance score'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                shareClass._fossil_bank_score
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total fossil fuel finance stock holdings'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.number(shareClass.fossil_bank_count)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total % invested in fossil fuel finance stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.perc(shareClass.fossil_bank_weight)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total assets invested in fossil fuel finance stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.money(shareClass.fossil_bank_asset, true, shareClass.currency, false)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stats-totals' },
            _react2.default.createElement(
              'div',
              { styleName: 'stats-totals-header' },
              'Fossil fuel insurance'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Fossil fuel insurance grade'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'badge-grade-wrap' },
                  _react2.default.createElement(_components.Grade, { grade: shareClass.grade_fossil_bank, blocksmall: true })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Fossil fuel insurance score'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                shareClass._fossil_insure_score
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total fossil fuel insurance stock holdings'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.number(shareClass.fossil_insure_count)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total % invested in fossil fuel insurance stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.perc(shareClass.fossil_insure_weight)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total assets invested in fossil fuel insurance stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.money(shareClass.fossil_insure_asset, true, shareClass.currency, false)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'stats-totals' },
            _react2.default.createElement(
              'div',
              { styleName: 'stats-totals-header' },
              'Clean200'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total Clean200 stock holdings'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.number(shareClass.cl_count)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total % invested in Clean200 stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.perc(shareClass.cl_weight)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'stats-total' },
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-name' },
                'Total assets invested in Clean200 stocks'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'stats-total-value' },
                _format2.default.money(shareClass.cl_asset, true, shareClass.currency, false)
              )
            )
          )
        )
      );
    };

    return _this;
  }

  (0, _createClass3.default)(FundInvestmentProfile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      _analytics2.default.event(_analytics2.default.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId));
      this._mounted = true;
      // const sector = this.props.sector ? this.props.sector : {}
      // this.props.sectorChange(sector)
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._mounted = false;
    }

    // need this solution since asyncConnect and anchor links does not play nice

  }, {
    key: 'render',
    value: function render() {
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      var _props$result = this.props.result,
          fund = _props$result.fund,
          shareClass = _props$result.shareClass;

      var title = shareClass.fund_legal_name + ' | Investment Profile';
      var ticker = shareClass.ticker ? shareClass.ticker : 'N';
      var name = _format2.default.sanitize(shareClass.fund_legal_name);
      var urlStart = _config2.default.routes.fund + '/' + name + '/' + ticker;
      var urlEnd = shareClass.fund_id + '/' + shareClass.investment_vehicle_id;
      var url = _config2.default.domain + urlStart + '/investment-profile/' + urlEnd;

      var _ticker = shareClass.ticker || null;
      var fundName = '' + fund.fund_legal_name;
      fundName = _ticker ? fundName + ' ' + _ticker : fundName;
      var ffAsset = _convert2.default.int(fund.c2f5coogutasset);
      var ffWeight = _convert2.default.float(fund.c2f5coogutweight);
      var _ffAsset = _format2.default.money(ffAsset, true, 'USD', false);
      var _ffWeight = _format2.default.perc(ffWeight);
      var description = fundName + ' has ' + _ffAsset + ' invested in fossil fuels, ' + _ffWeight + ' of the fund';

      var scoreFormatterFn = function scoreFormatterFn(s) {
        var _s = _format2.default.number(s, false, false, 1);
        if (parseFloat(_s) === 0 && parseFloat(s) > 0) {
          _s = '<0.1';
        } else if (_s.slice(-1) === '0' && parseFloat(s) <= 0) {
          _s = _format2.default.number(s, false, false, 0);
        }
        return _s;
      };

      shareClass._fossil_bank_score = scoreFormatterFn(shareClass.fossil_bank_score);
      shareClass._fossil_insure_score = scoreFormatterFn(shareClass.fossil_insure_score);

      //
      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.FundMenu, {
          active: 'More',
          fundId: shareClass.fund_id,
          investmentVehicleId: shareClass.investment_vehicle_id,
          name: shareClass.fund_legal_name,
          ticker: shareClass.ticker
        }),
        _react2.default.createElement(_components.FundName, {
          shareClass: shareClass,
          pathname: this.props.location.pathname
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          this.renderStats(shareClass)
        ),
        _react2.default.createElement(_components.IyvScorecard, {
          fund: fund,
          shareClass: shareClass
        }),
        _react2.default.createElement(_components.FundShareTakeAction, {
          shareClass: shareClass,
          url: url,
          type: 'investment-profile'
        })
      );
    }
  }]);
  return FundInvestmentProfile;
}(_react.Component), _class2.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = FundInvestmentProfile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundInvestmentProfile/FundInvestmentProfile.js
// module id = 1405
// module chunks = 0